import React, {useCallback, useReducer, useState} from 'react';
import { Alert, Card, CardBody, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { useAuth, useLogin, ValidatorProvider } from 'react-admin-base';
import AuthLayout from 'react-admin-base-adminkit/lib/esm/Auth/Layout';
import {Validator, LoadingButton} from "react-admin-base-bootstrap";
import {FormattedMessage} from "react-intl";
import { LanguageSwitcherBasic } from '../i18n';

export default function Register() {
    const [ api ] = useAuth();
    const login = useLogin();

    const [ data, setData ] = useReducer((a, b) => ({ ...a, ...b }), {});

    const [ step, setStep ] = useState(1);

    const [ code, setCode ] = useState('');
    const [ password2, setPassword2] = useState('');
    const [ signature, setSignature ] = useState('');

    const [ loading, setLoading] = useState(false);
    const [ error, setError ] = useState(null);

    const handleSubmit = useCallback(async function(e) {
        e.preventDefault();

        if (loading)
            return false;

        setError(null);
        setLoading(true);
        try {
            console.log(step);
            switch (step) {
                case 1:
                    let _signature = (await api.free.post('/register', data)).data;
                    setStep(2);
                    setSignature(_signature);
                    break;
                case 2:
                    await api.free.post(signature, data, { params: { code } });
                    await api.log_in(data.email, data.password);

                    setStep(1);

                    break;
            }
        } catch(e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    }, [signature, api, code, data, step, setError, loading]);

    const changeEmail = useCallback(function() {
        setStep(1);
    }, [setStep]);

    return <AuthLayout>
        <p className="text-center mb-4">Register</p>

        <Card>
            <CardBody>
                <ValidatorProvider>
                    <Form onSubmit={handleSubmit}>
                        { step === 1 && <>
                            <FormGroup>
                                <Label><FormattedMessage id="NAME" /></Label>
                                <Validator name="name" type="required">
                                    <Input
                                        type="text"
                                        value={data.name || ''}
                                        label="name"
                                        onChange={a => setData({ name: a.currentTarget.value })}
                                        disabled={loading}
                                    />
                                </Validator>
                            </FormGroup>
                            <FormGroup>
                                <Label><FormattedMessage id="EMAIL_ADDRESS" /></Label>
                                <Validator name="" type="required|email">
                                    <Input
                                        type="text"
                                        value={data.email || ''}
                                        label="Email"
                                        onChange={a => setData({ email: a.currentTarget.value })}
                                        disabled={loading}
                                        autoComplete="username"
                                    />
                                </Validator>
                            </FormGroup>
                            <FormGroup>
                                <Label><FormattedMessage id="PASSWORD" /></Label>
                                <Validator name="password" type="required">
                                    <Input
                                        type="password"
                                        value={data.password || ''}
                                        onChange={a => setData({ password: a.currentTarget.value })}
                                        disabled={loading}
                                        autoComplete="new-password"
                                    />
                                </Validator>
                            </FormGroup>
                            <FormGroup>
                                <Label><FormattedMessage id="PASSWORD_REPEAT" /></Label>
                                <Validator name="password2" type={["required", { in: data.password || '' }]}>
                                    <Input
                                        type="password"
                                        value={password2 || ''}
                                        onChange={a => setPassword2(a.currentTarget.value) || setError(null)}
                                        disabled={loading}
                                        autoComplete="new-password"
                                    />
                                </Validator>
                            </FormGroup>
                        </> }

                        { step === 2 && <>
                            <FormGroup>
                                <Label><FormattedMessage id="AUTH_CODE" /></Label>
                                <Validator name="code" type="required">
                                    <Input
                                        type="text"
                                        value={code || ""}
                                        onChange={a => setCode(a.currentTarget.value)}
                                        placeholder={'Authorization Code'}
                                        disabled={!!loading}
                                    />
                                </Validator>
                            </FormGroup>
                            <p className="text-left font-14">
                                <FormattedMessage id="ENTER_AUTH_CODE" values={{ email: <b>{data.email}</b> }} />
                            </p>
                            <p className="text-left font-14">
                                <FormattedMessage id="CHANGE_EMAIL" values={{ a: text => <a href="#" onClick={changeEmail}>{text}</a> }} />
                            </p>
                        </> }

                        { error && <Alert color="danger" toggle={a => setError(null)}>{ error.message }</Alert> }
                        <div className="text-center mt-4">
                            <LoadingButton block type="submit"  size="lg" color="primary" loading={loading}><FormattedMessage id="SUBMIT" /></LoadingButton>
                        </div>
                    </Form>
                </ValidatorProvider>
            </CardBody>
        </Card>
        <LanguageSwitcherBasic className="mt-3" />
    </AuthLayout>;
}
